import React from 'react'
import CreatePaymentContainer from 'containers/panel/admin/create-payment-container'

const CreatePaymentPage = () => {
  return (
    <CreatePaymentContainer/>
  )
}

export default CreatePaymentPage